import { TOGGLE_CENTER_NOTIFICATION, SET_OVERLAY_ACTIVE } from '../actions/centerNotifications';

const initialState = {
  isOpen: true,
  isOverlayActive: false
};

function centerNotificationsReducer(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_CENTER_NOTIFICATION:
      return {
        ...state,
        isOpen: !state.isOpen
      };
    case SET_OVERLAY_ACTIVE:
      return {
        ...state,
        isOverlayActive: action.payload
      };
    default:
      return state;
  }
}

export default centerNotificationsReducer;


// WEBPACK FOOTER //
// ./src/reducers/centerNotifications.js